import { GET } from '../../common/common.service'
import endpointsMargin from './endpoints'

export const MarginService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsMargin.LOAD({ filter, sort, limit, skip })),
  getAllByOwnSttion: async ({ id, filter, sort, limit, skip }) =>
    GET(endpointsMargin.LOAD_BY_OWN_STATION({ id, filter, sort, limit, skip })),
}
